import React, { useState } from "react";
import { trashGalleryIcon, GalleryVideo } from "../../Components";

export default function GalleryGridItem(props) {
  console.log("🚀 ~ GalleryGridItem ~ props:", props);
  const [showActionIcon, setShowActionIcon] = useState(false);

  const confirmDelete = (id) => {
    props.setShowConfirmInfModal(true);
    props.setIndexForAction(id);
    props.setShowConfirmDelete(true);
  };

  return (
    <div className="relative group overflow-hidden rounded-2xl">
      {props.newAddedImage && (
        <div className="absolute top-2 right-2 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <div
            className={`p-2 cursor-pointer rounded-lg ${
              props.status === "visible"
                ? "bg-red-50 text-white"
                : "bg-gray-800 text-white"
            }`}
            onClick={() => confirmDelete(props.indexForItem)}
          >
            {trashGalleryIcon}
          </div>
        </div>
      )}

      <div className="assetsItem__header galleryItem">
        <div className="assetsItem__header-media">
          {props.media_type_id === 2 &&
            (props.mediafile || props.thumbnail_url) && (
              <div className="galleryImage gallerylist">
                <img
                  src={props.thumbnail_url ?? props.mediafile}
                  alt={props.thumbnail_url ?? props.mediafile}
                  className="gallerylistImg w-full h-auto object-cover rounded-2xl"
                />
              </div>
            )}
          {props.media_type_id === 1 && (
            <GalleryVideo setShowActionIcon={setShowActionIcon} {...props} />
          )}
        </div>
      </div>

      {/* Hover overlay - contained within rounded borders */}
      <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300 pointer-events-none" />
    </div>
  );
}
